import { createFileRoute } from '@tanstack/react-router';
import { PLAN_PARAM_TO_PRODUCT, PlanTypeParam } from 'utils/billing';

import { BillingProducts } from 'component/partial/Settings/Billing/Plans/BillingProducts';

const planTypeValues = new Set<string>(Object.values(PlanTypeParam));

// The parent route checks availability.
export const Route = createFileRoute('/n/_auth/settings/_layout/billing/edit-plan/_tabs/$planType')(
  {
    params: {
      parse: (rawParams): { planType: PlanTypeParam } => {
        if (!planTypeValues.has(rawParams.planType)) {
          throw new Error(`Invalid plan type: ${rawParams.planType}`);
        }
        return { planType: rawParams.planType as PlanTypeParam };
      },
      stringify: params => ({ planType: params.planType }),
    },
    component: PlanTypeRoute,
  }
);

function PlanTypeRoute() {
  const { planType } = Route.useParams();

  return <BillingProducts billingProductType={PLAN_PARAM_TO_PRODUCT[planType]} />;
}
